export default "__VITE_ASSET__BO9igH3q__"